import { CreatePlaylistResponse } from '../types/playlist';

export async function createPlaylist(artistName: string, songs: string[]): Promise<CreatePlaylistResponse> {
  const res = await fetch('/api/v1/playlists', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ artistName, songs }),
  });

  if (!res.ok) {
    if (res.status === 401) throw new Error('Please log in to Spotify first.');
    if (res.status === 403) {
      const err = await res.json().catch(() => ({}));
      if (err.error === 'insufficient_scope') {
        throw new Error('Re-authenticate with Spotify to allow playlist creation.');
      }
      throw new Error('Access denied.');
    }
    if (res.status >= 500) throw new Error('Playlist service is temporarily unavailable. Please try again shortly.');
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to create playlist');
  }

  return res.json();
}
